module.exports = __webpack_public_path__ + "img/endHome.f542cfef.jpg";